import type { DataSet, Point } from "@incytestudios/ddv";
import type { GasCurveChartContext } from "./d";
import { Ratio } from "@/libs/units/percentage";

const getDataPoints = (context: GasCurveChartContext): Point[] => {
  const { ascendingOrderPumps, individualPumpCalculations } = context;
  let currentStage = 0;
  return ascendingOrderPumps.flatMap(xrefPump => {
    return individualPumpCalculations[xrefPump.id].stageCalculations.flatMap(
      stageCalc => {
        const x = (currentStage += 1);
        return {
          x,
          y: Ratio.toStandardUnit(
            stageCalc.intakeFluidPropertiesContext.fluidProperties
              .gasFlowVolumeRatio
          )
        };
      }
    );
  });
};

export const getFreeGasDataSet = (context: GasCurveChartContext): DataSet => {
  const points = getDataPoints(context);
  return {
    title: "Gas Curve",
    xAxisLabel: "Stage",
    yAxisLabel: "% Free Gas",
    points
  };
};
